import React from 'react'
import PropTypes from 'prop-types'

const AutomateCallIcon = (props) => {
  const {
    color = '#183560',
    classes = 'w-20',
    revert = false,
    notBackground = false,
    backgroundColor = '#ffffff',
  } = props

  const colorIcon = revert ? '#ffffff' : color
  const background = notBackground ? 'none' : revert ? color : backgroundColor

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
        fill={background}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7877 4.2149C13.1865 1.61464 8.72143 3.46606 8.72143 7.14105C8.72143 10.8159 13.1865 12.6675 15.7877 10.0672C17.4041 8.45114 17.4041 5.83097 15.7877 4.2149ZM9.13253 14.7998L9.13299 14.7987C9.25421 14.8631 9.4081 14.84 9.50426 14.7336L10.4106 13.7316L13.2707 14.5878V17C7.6719 16.8399 3.15949 12.3294 3 6.72976H5.41134L6.26808 9.59043L5.28639 10.4779C5.16705 10.5672 5.12737 10.7325 5.19941 10.8683C6.08727 12.5382 7.46231 13.9119 9.13253 14.7998ZM13.1525 3.99728V6.84923H15.4336V7.43256H12.569V3.99728H13.1525Z"
        fill={colorIcon}
      />
    </svg>
  )
}

AutomateCallIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
  revert: PropTypes.bool,
  notBackground: PropTypes.bool,
  backgroundColor: PropTypes.string,
}

export default React.memo(AutomateCallIcon)
